/* eslint-disable import/prefer-default-export */
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

import { Text } from '@knowz/knowz-ui';

export const StyledText = styled(Text, {
  shouldForwardProp: (prop) =>
    prop !== 'isLoading' && prop !== 'isSourceDetailsError',
})(({ theme, isLoading, isSourceDetailsError }) => ({
  color: isSourceDetailsError
    ? theme.palette.error.main
    : theme.palette.primary[500],

  '&:hover': {
    cursor: isLoading || isSourceDetailsError ? 'default' : 'pointer',
    textDecoration: isLoading || isSourceDetailsError ? 'none' : 'underline',
  },
}));

export const StyledNotificationContentStack = styled(Stack)(({ theme }) => ({
  '& .mdxeditor-root-contenteditable > div > div': {
    padding: 0,
  },

  '& .mdxeditor p': {
    margin: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.textXs.fontSize,
    fontWeight: theme.typography.fontWeightMedium,

    '& strong': {
      fontWeight: theme.typography.fontWeightSemibold,
    },
  },
}));

export const StyledAvatarContainer = styled(Box)(() => ({
  position: 'relative',
}));

export const StyledBadge = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 23,
  right: -3,
  backgroundColor: theme.palette.success.main,
  width: 12,
  height: 12,
  borderRadius: '50%',
  border: `2px solid ${theme.palette.background.paper}`,
}));
